<template>
  <section class="appRadioGroup">
    <v-radio-group v-model="model" row>
      <v-radio
        v-for="(item, index) in items"
        :key="index"
        class="appRadioGroup-item"
        :label="item.label"
        :value="item.value"
        color="#CC0000"
      ></v-radio>
    </v-radio-group>
  </section>
</template>

<script>
export default {
  name: 'AppRadioGroup',
  props: {
    value: {
      type: [Number, String, Object],
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.appRadioGroup {
  width: 100%;
  &::v-deep .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
  }
  &::v-deep .theme--light.v-messages {
    display: none;
  }
  &::v-deep .v-input--radio-group.v-input--radio-group--row .v-radio {
    padding: 10px 15px;
    width: 50%;
    margin-right: 0px;
    background-color: #FFF;
  }
  &::v-deep .v-input--radio-group--row .v-input--radio-group__input {
    flex-wrap: nowrap;
  }
  &-item {
    &:not(:first-child) {
      margin-left: 20px;
    }
    border: solid 2px #ccc;
    border-radius: 5px;
    &.v-item--active{
      border-color:#CC0000;
    }
    &::v-deep .v-label.theme--light {
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #333;
    }
  }
}
</style>
